import { memo } from 'react';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CircularProgress,
  Grid,
  Skeleton,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import LogoOne7Ai from '../../../../assets/img/logo_one7_ai.png';
import useContaCorrenteCessaoHook from '../hooks/useContaCorrenteCessaoHook';
import './ContaCorrenteCessao.scss';
import ModalCadastroConta from './ModalCadastroConta/ModalCadastroConta';
import ModalConfirmacaoConta from './ModalConfirmacaoConta/ModalConfirmacaoConta';
import ModalCancelarCessao from '../componentes/ModalCancelarCessao/ModalCancelarCessao';
import ModalFinalizaCessao from '../componentes/ModalFinalizaCessao/ModalFinalizaCessao';
import ModalTitulosCedidos from '../componentes/ModalTitulosCedidos/ModalTitulosCedidos';

const UploadCessao = ({ escopoAcesso, setEscopoAcesso, setCarregarTela }) => {
  const {
    handleCloseDialogConfirmacao,
    handleOpenDialogConfirmacao,
    onCloseModalTitulosCedidos,
    irParaTelaHistoricoCessao,
    loadingBtnConfirmarConta,
    openModalFinalizaCessao,
    openModalTitulosCedidos,
    verificaTitulosCedidos,
    onCloseFinalizaCessao,
    buscarContasCorrentes,
    openDialogConfirmacao,
    setOpenModalCancelar,
    onCloseModalCancelar,
    aplicaContacorrente,
    openModalCancelar,
    handleCloseDialog,
    loadingProsseguir,
    handleOpenDialog,
    textoConfirmacao,
    voltarParaUpload,
    contaSelecionada,
    loadingContas,
    openDialog,
    accounts
  } = useContaCorrenteCessaoHook({
    escopoAcesso,
    setEscopoAcesso,
    setCarregarTela
  });

  return (
    <Grid container className="container-sessao">
      <Grid item xs={12}>
        <Box className="sessao-topo">
          <Box className="subtitulo-sessao">
            <Button className="btn-voltar-sessao" onClick={() => voltarParaUpload()}>
              <KeyboardBackspaceIcon />
              voltar
            </Button>
            <Box className="titulo-sessao">Nova cessão</Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="box-limite-disponivel">
          <Box className="box-logo">
            <img src={LogoOne7Ai} className="logo-one-ai" alt="Logo One AI" />
          </Box>

          <Box className="box-finalizacao-cessao">
            <Box className="box-label-superior">COMO ÚLTIMO PASSO SELECIONE A CONTA DE RECEBIMENTO</Box>
            <Box className="box-label-inferior">
              Caso seja aprovado selecione a conta para receber o crédito
            </Box>

            <Box className="box-finalizacao">
              <Grid container spacing={2}>
                {loadingContas &&
                  [1, 2, 3].map(s => (
                    <Grid item xs={12} sm={6} md={4} key={s}>
                      <Card className="conta-card">
                        <Box className="conta-card__content">
                          <Skeleton
                            width="95%"
                            height={40}
                            className="skeleton-custom"
                            animation="wave"
                          />

                          <Box className="conta-card__linha-inferior mt-2">
                            <Box>
                              <Skeleton
                                width="75%"
                                height={25}
                                className="skeleton-custom"
                                animation="wave"
                              />
                              <Skeleton
                                width={80}
                                height={30}
                                className="skeleton-custom"
                                animation="wave"
                              />
                            </Box>

                            <Box>
                              <Skeleton
                                width="75%"
                                height={25}
                                className="skeleton-custom"
                                animation="wave"
                              />
                              <Skeleton
                                width={80}
                                height={30}
                                className="skeleton-custom"
                                animation="wave"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Card>
                    </Grid>
                  ))}

                {!loadingContas &&
                  accounts.map(acc => (
                    <Grid item xs={12} sm={6} md={4} key={acc.id}>
                      <Card
                        className={`conta-card ${contaSelecionada === acc.id ? 'selecionada' : ''}`}
                        onClick={() => handleOpenDialogConfirmacao(acc.id)}
                      >
                        <Box className="conta-card__content">
                          {contaSelecionada === acc.id && (
                            <Typography variant="subtitle1" noWrap className="conta-selecionada">
                              Conta selecionada
                            </Typography>
                          )}

                          <Typography
                            variant="subtitle1"
                            noWrap
                            className={`conta-card__titulo ${contaSelecionada === acc.id ? 'selecionada' : ''}`}
                          >
                            {acc.CODBANCO} - {acc.NOME}
                          </Typography>

                          <Box className="conta-card__linha-inferior">
                            <Box>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                className={`conta-card__label ${contaSelecionada === acc.id ? 'selecionada' : ''}`}
                              >
                                Agência
                              </Typography>
                              <Typography variant="body2">
                                {acc.CODAGENCIABANCO}
                                {acc.DIGAGENCIA ? `-${acc.DIGAGENCIA}` : ''}
                              </Typography>
                            </Box>

                            <Box>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                className={`conta-card__label ${contaSelecionada === acc.id ? 'selecionada' : ''}`}
                              >
                                Conta
                              </Typography>
                              <Typography variant="body2">
                                {acc.CODCC}
                                {acc.DIGCC ? `-${acc.DIGCC}` : ''}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Card>
                    </Grid>
                  ))}

                {!loadingContas && (
                  <Grid item xs={12} sm={6} md={4}>
                    <CardActionArea onClick={handleOpenDialog}>
                      <Box className="conta-card-add">
                        <Typography variant="body2">Adicionar nova conta</Typography>
                      </Box>
                    </CardActionArea>
                  </Grid>
                )}
              </Grid>

              <ModalCadastroConta
                open={openDialog}
                onClose={handleCloseDialog}
                buscarContasCorrentes={buscarContasCorrentes}
              />

              <ModalConfirmacaoConta
                open={openDialogConfirmacao}
                loadingProsseguir={loadingProsseguir}
                onClose={handleCloseDialogConfirmacao}
                aplicaContacorrente={aplicaContacorrente}
                loadingBtnConfirmarConta={loadingBtnConfirmarConta}
              />
            </Box>
          </Box>

          <Box className="box-btn-finalizacao">
            <Button className="btn-cancelar" onClick={() => setOpenModalCancelar(true)}>
              Cancelar
            </Button>
            <Button
              className="btn-processeguir-finalizacao"
              onClick={() => verificaTitulosCedidos()}
              disabled={loadingProsseguir || !contaSelecionada}
            >
              <Box className="box-icone">
                {!loadingProsseguir && <>Finalizar cessão</>}
                {loadingProsseguir && (
                  <>
                    Finalizando a cessão &nbsp;
                    <CircularProgress size={20} color="inherit" />
                  </>
                )}
              </Box>
            </Button>
          </Box>
        </Box>
      </Grid>

      <ModalCancelarCessao open={openModalCancelar} onClose={onCloseModalCancelar} />

      <ModalFinalizaCessao
        open={openModalFinalizaCessao}
        onClose={onCloseFinalizaCessao}
        textoConfirmacao={textoConfirmacao}
        irParaTelaHistoricoCessao={irParaTelaHistoricoCessao}
      />

      <ModalTitulosCedidos
        open={openModalTitulosCedidos}
        onClose={onCloseModalTitulosCedidos}
        setCarregarTela={setCarregarTela}
      />
    </Grid>
  );
};

export default memo(UploadCessao);
